import React, { useEffect, useState } from 'react';
import { ErrorMsg, FloatInput, FloatLabelDiv } from '../styled';

function Text(props) {
  const { element, index } = props;
  const [userEnteredValue, setUserEnteredValue] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const validateInput = (value) => {
    if (element.required == '1' && value.trim() == '') {
      return 'This field is required.';
    } else if (element.prefilled_type == '3' && value.trim().length < 10) {
      return 'Please enter a valid mobile number.';
    }

    return '';
  };

  useEffect(() => {
    if (!element.answer_text) {
      setUserEnteredValue('');
      setErrorMsg('');
    }
  }, [element.answer_text]);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setUserEnteredValue(newValue);
    element.answer_text = newValue;
    const error = validateInput(newValue);
    element.errorMsg = error;
    setErrorMsg(error);
  };

  const handleBlur = () => {
    const error = validateInput(userEnteredValue);
    element.errorMsg = error;
    setErrorMsg(error);
  };

  return (
    <>
      <FloatLabelDiv>
        <FloatInput
          type="text"
          placeholder={element.question_text}
          onChange={handleChange}
          onBlur={handleBlur}
          required={true}
          value={userEnteredValue}
          // autoFocus={index == 0}
          hasError={errorMsg}
        />
        {errorMsg && <ErrorMsg>{errorMsg}</ErrorMsg>}
      </FloatLabelDiv>
    </>
  );
}

export default Text;
